import { useState } from 'react';

function useSealedState(initialState) {
  var _React$useState = useState(initialState),
      sealed = _React$useState[0];

  return sealed;
}

export { useSealedState };
